/**
 * Image Zoom Listener (V2)
 * Event registration only.
 */

import type { ImageZoomForm } from "./image-zoom-form";
import type { ImageZoomHandler } from "./image-zoom-handler";

export class ImageZoomListener {
    public form: ImageZoomForm;

    public handler: ImageZoomHandler;

    public constructor(form: ImageZoomForm, handler: ImageZoomHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const source = this.form.getSource();
        const root = this.form.root;
        if (!(source instanceof HTMLElement)) return;

        source.addEventListener("mousemove", (event) => {
            if (root.dataset.imageZoomDisabled === "1") return;
            this.handler.handlePointerMove(event.clientX, event.clientY);
        });

        source.addEventListener("mouseenter", (event) => {
            if (root.dataset.imageZoomDisabled === "1") {
                root.dataset.imageZoomActive = "0";
                return;
            }
            root.dataset.imageZoomActive = "1";
            this.handler.handlePointerMove(event.clientX, event.clientY);
        });

        source.addEventListener("mouseleave", () => {
            root.dataset.imageZoomActive = "0";
            this.handler.resetOrigin();
        });
    }
}
